import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import RatingSmiley from 'src/components/rating/smiley-rating';
import { RatingContainer } from './styles';
import { MediumUp, MobileOnly } from 'src/ui/block';

export const StoreRatingAverage: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { offer } = usePriceRowContext();
  const { store, rating } = offer;

  if (!store || !rating || rating.whole <= 0) {
    return null;
  }

  return (
    <RatingContainer data-rating={rating.roundedString}>
      <MobileOnly>
        <RatingSmiley
          featured={Boolean(store.featured)}
          rating={rating}
          scoreVisibility="row"
          size="small"
        />
      </MobileOnly>

      <MediumUp>
        <RatingSmiley
          featured={Boolean(store.featured)}
          rating={rating}
          scoreVisibility="row"
          size="small"
          reviewCount={store.userReviewSummary.countTotal}
        />
      </MediumUp>
    </RatingContainer>
  );
};
